/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nav_Badge_TradesInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} person is waiting on you to trade" |
* | * | "{count} people are waiting on you to trade" |
*
* @param {Nav_Badge_TradesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_badge_trades = /** @type {((inputs: Nav_Badge_TradesInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Badge_TradesInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const countPlural = registry.plural("de", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Person wartet auf einen Tausch mit dir`);
		return /** @type {LocalizedString} */ (`${i?.count} Personen warten auf einen Tausch mit dir`)
	}
	if (locale === "fr") {
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} personne attend un échange avec vous`);
		return /** @type {LocalizedString} */ (`${i?.count} personnes attendent un échange avec vous`)
	}
	if (locale === "zh-Hans") {
		const countPlural = registry.plural("zh-Hans", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 人正在等你完成交换`);
		return /** @type {LocalizedString} */ (`${i?.count} 人正在等你完成交换`)
	}
	if (locale === "zh-Hant") {
		const countPlural = registry.plural("zh-Hant", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`有 ${i?.count} 位玩家正在等你交易`);
		return /** @type {LocalizedString} */ (`有 ${i?.count} 位玩家正在等你交易`)
	}
	if (locale === "ko") {
		const countPlural = registry.plural("ko", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}명이 교환을 기다리고 있습니다`);
		return /** @type {LocalizedString} */ (`${i?.count}명이 교환을 기다리고 있습니다`)
	}
	{
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} person is waiting on you to trade`);
		return /** @type {LocalizedString} */ (`${i?.count} people are waiting on you to trade`)
	}
});